<template>
  <div class="settlement-payments-list page page-with-table p-2">
    <page-header class="mb-2">
      <template v-slot:title>
        <div style="flex: 1">
          <h1 class="mb-0">{{ $t('Settlement Payments') }}</h1>
        </div>
      </template>
    </page-header>
    <div class="card content-wrapper">
      <div class="pl-2 pr-2 pt-2  pb-0">
        <div class="row">
          <div class="col-md-4">
            <amount-viewer :title="$t('Total Amount')" text-class="text-primary" key="items-general-info"
                           :amount="totalAmount" icon="money-bill"/>
          </div>
        </div>
      </div>
      <SettlementPaymentTable :hide-actions="hideSettlementActions" :hide-action-buttons="hideActionButtons"
                     enable-frontend-export/>
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import PageHeader from "@/core/components/page-header/PageHeader";
  import AmountViewer from "@/core/components/common/AmountViewer";
  import SettlementPaymentTable from "@/modules/settlement-payments/SettlementPaymentTable";
  import {ON_SETTLEMENT_PAYMENT_TABLE_GET_TABLE_DATA} from "@/plugins/event-bus/event-bus-names";
  import SettlementService from "@/modules/settlements/SettlementService";

  const {mapActions: settlementsMapActions} = createNamespacedHelpers('settlementPayments');

  export default {
    name: "SettlementPayments",
    components: {SettlementPaymentTable, AmountViewer, PageHeader},
    data() {
      return {
        hideActions: [],
        hideActionButtons: [],
        totalAmount: {}
      }
    },
    computed: {
      hideSettlementActions() {
        let actions = _.cloneDeep(this.hideActions)
        return this.enableContinuousAuction ? actions : [...actions];
      },
    },
    methods: {
      ...settlementsMapActions(['updateTableSource']),
      async getFilteredSettlementTotalAmounts({params}) {
        let response = await SettlementService.getSettlementPaymentsTotalAmounts(params);
        if (response.success) {
          this.$set(this, 'totalAmount', response.body.total_amount);
        }
      },
    },
    async beforeMount() {
      this.$evBus.$on(ON_SETTLEMENT_PAYMENT_TABLE_GET_TABLE_DATA, this.getFilteredSettlementTotalAmounts);
      await this.updateTableSource({
        source: 'finance',
      });
    },
    beforeDestroy() {
      this.$evBus.$off(ON_SETTLEMENT_PAYMENT_TABLE_GET_TABLE_DATA);
    }
  }
</script>

<style scoped lang="scss">
  @import "./scss/variables.scss";

  .settlement-payments-list {
    @include list-view-wrapper;
  }
</style>
